import type { InterventionSchedulingState } from "@/entities/intervention";
import type { ReferentialSchedulingState } from "@/entities/referential/referential-scheduling-states";

export const getIndicatorSubTypes = (
  schedulingState?: InterventionSchedulingState,
  referential?: ReferentialSchedulingState[]
) => {
  if (!schedulingState || !referential?.length) return undefined;

  const schedulingStateValues: number[] = [];

  // Back-end referential values are combined-values.
  for (const ref of referential) {
    const value = ref.value;

    if (value & schedulingState) schedulingStateValues.push(value);
  }

  return [...new Set(schedulingStateValues)];
};

export const getIndicatorTooltipFallback = (
  referential: ReferentialSchedulingState[]
) => {
  if (!referential.length) return undefined;

  return referential.reduce<Record<number, string>>((acc, refData) => {
    return {
      ...acc,
      [refData.value]: refData.description,
    };
  }, {});
};
